import React from 'react'
import { render } from 'react-dom'
// CSS Style
import './styles/index.scss'
// Website routes Components
import Routes from './Routes'

render(<Routes />, document.getElementById('root'))
